import { DownCircle } from "@/components/Icons";
import events, { MessageType } from "@/utils/events";
import { Box, Flex, Text, useBoolean, Image } from "@chakra-ui/react";
import { useCallback, useMemo } from "react";
import BusinessButton from "../BusinessButton";
import ImageCard from "../ImageCard";
import IntroCard, { IntroCardProps } from "../IntroCard";

const featureList = [
  {
    title: "通用文生图",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E9%80%9A%E7%94%A8%E6%96%87%E7%94%9F%E5%9B%BE.png",
    desc: "输入文本描述，生成符合文本描述的图像，可用于 AI 绘画等场景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "通用图生图",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E9%80%9A%E7%94%A8%E5%9B%BE%E7%94%9F%E5%9B%BE.png",
    desc: "输入图片和文本描述，生成符合图片参考和文本描述的图像，可用于 AI 绘画等场景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "文本生成",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E6%96%87%E6%9C%AC%E7%94%9F%E6%88%90.png",
    desc: "输入文本，生成文本回复，使用 GPT 模型，可用于聊天对话、文本问答等场景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-63131650?nav=1",
  },
  {
    title: "商品场景生成",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E5%95%86%E5%93%81%E5%9B%BE2.png",
    desc: "输入商品照片及场景主题选项或场景描述文本，生成该商品在该场景下的摄影结果",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-59337374?nav=1",
    disableJump: true,
  },
  {
    title: "人像 AI 绘画",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E4%BA%BA%E5%83%8F%20AI%20%E7%BB%98%E7%94%BB.png",
    desc: "输入人像照片及风格选项，生成该风格的该人像艺术风格化图像",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-54025157?nav=1",
  },
  {
    title: "训练艺术人像",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E8%AE%AD%E7%BB%83%E8%89%BA%E6%9C%AF%E4%BA%BA%E5%83%8F.png",
    desc: "输入同一人的多张人像照片，经过模型训练，生成多张该人的多张艺术化肖像",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-61594908?nav=1",
  },
  {
    title: "Prompt 优化",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E6%8F%90%E7%A4%BA%E8%AF%8D%E4%BC%98%E5%8C%96.png",
    desc: "输入文本，生成优化后的 Prompt，可用于文生图的关键词优化，以生成效果更好的图片",
    jumpUrl: "javascript:void(0)",
    disableJump: true,
  },
  {
    title: "抠图（移除背景）",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E6%8A%A0%E5%9B%BE.png",
    desc: "保留图像前景主体，除图像背景，可用于图片智能编辑等场景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-58019814?nav=1",
  },
  {
    title: "图像外延",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E5%A4%96%E5%BB%B6.png",
    desc: "填补图像之外的画面，可用于图片智能编辑等场景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "图像局部去除",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E5%B1%80%E9%83%A8%E5%8E%BB%E9%99%A4.png",
    desc: "将图片中指定区域内容去除，并智能补全背景",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "图像局部替换",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E5%B1%80%E9%83%A8%E6%9B%BF%E6%8D%A2.png",
    desc: "将图片中指定区域的画面内容替换为输入的文本所描述的画面内容",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "图像高清（超分辨率）",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E9%AB%98%E6%B8%85.png",
    desc: "提升低分辨率图像的清晰度",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "图片生成文本",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E5%9B%BE%E7%89%87%E8%BD%AC%E6%96%87%E5%AD%97.png",
    desc: "输入图片，生成图片的文本描述，可用于 Prompt 提取等",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-56208288?nav=1",
  },
  {
    title: "AI 绘画模型训练和推理",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E6%9B%B4%E5%A4%9A%20API-1.png",
    desc: "输入图片样本集和训练参数以模型训练，可得到训练后的模型，并可使用此模型进行推理",
    jumpUrl: "https://creator-nolibox.apifox.cn/api-62888280?nav=1",
  },
  {
    title: "更多 API",
    src: "http://nolipix-js.nolibox.com/assets/creator/business/%E6%9B%B4%E5%A4%9A%20API.png",
    desc: "更多先进 AI 技术的 API，敬请期待",
    jumpUrl: "",
    disableJump: true,
  },
];
function APIPanel() {
  const [expand, expandOp] = useBoolean(false);

  const onBtnClick: React.MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
    const t = e.target as HTMLButtonElement;
    switch (t.name) {
      case "doc":
        window.open("https://creator-nolibox.apifox.cn", "_blank");
        break;
      case "api":
        window.open("https://open.creator.nolibox.com", "_blank");
        break;
      case "pop":
        events.emit(MessageType.BUSINESS_MODAL);
        break;
    }
  }, []);

  const serviceList: IntroCardProps[] = useMemo(() => {
    return [
      {
        title: "积分模式",
        desc: "适用于少量、低并发调用",
        featureList: [
          {
            text: "预充值，换购对应数量的积分",
            enable: true,
          },
          {
            text: "每次 API 调用消耗对应数量的积分",
            enable: true,
          },
          {
            text: "单笔充值越多，购得积分优惠力度越大",
            enable: true,
          },
          {
            text: "有实时提交任务数限制",
            enable: false,
          },
          {
            text: "不提供专属的任务队列",
            enable: false,
          },
        ],
        isHot: false,
        button: (
          <BusinessButton
            theme="white"
            icon="consult"
            text="客制咨询"
            onClick={onBtnClick}
            name="pop"
            w="100%"
            mr="0"
          />
        ),
      },
      {
        title: "包月 / 包年模式",
        desc: "适用于大量、高并发调用",
        featureList: [
          {
            text: "为客户提供专用的 GPU 服务器",
            enable: true,
          },
          {
            text: "将模型和算法免费部署在为客户提供的专用 GPU 服务器上",
            enable: true,
          },
          {
            text: "单笔充值越多，购得积分优惠力度越大",
            enable: true,
          },
          {
            text: "订阅期内，核心功能无限次使用",
            enable: true,
          },
          {
            text: "提交任务数无限制",
            enable: true,
          },
          {
            text: "为客户提供专属的任务队列",
            enable: true,
          },
        ],
        isHot: true,
        button: (
          <BusinessButton
            theme="white"
            icon="consult"
            text="客制咨询"
            onClick={onBtnClick}
            name="pop"
            w="100%"
            mr="0"
          />
        ),
      },
      {
        title: "一次性部署模式",
        desc: "适用于有技术和运维经验的团队",
        featureList: [
          {
            text: "由客户自己提供 GPU 服务器",
            enable: false,
          },
          {
            text: "将模型和算法部署在客户自己提供的 GPU 服务器上",
            enable: true,
          },
          {
            text: "部署后，核心功能无限次使用",
            enable: true,
          },
          {
            text: "提交任务数无限制",
            enable: true,
          },
          {
            text: "为客户部署专属的任务队列",
            enable: true,
          },
        ],
        isHot: false,
        button: (
          <BusinessButton
            theme="white"
            icon="consult"
            text="客制咨询"
            onClick={onBtnClick}
            name="pop"
            w="100%"
            mr="0"
          />
        ),
      },
    ];
  }, [onBtnClick]);

  return (
    <Box w="100%">
      <Box>
        {/* <Box>
          <Image src={"http://nolipix-js.nolibox.com/assets/creator/business/news_banner.jpg"} />
        </Box> */}
        <Text fontSize="28px" fontWeight={600} textAlign="center" mt="64px" mb="24px">
          开箱即用的 AIGC API
        </Text>
        <Text textAlign="center" mb="32px">
          将先进的图文 AI 直接集成到您的产品中
        </Text>
        <Flex justify="center" mb="36px">
          {/* <BusinessButton theme="blue" text="API 文档" name="doc" onClick={onBtnClick} icon="doc" />
          <BusinessButton
            theme="white"
            text="使用 API"
            name="api"
            onClick={onBtnClick}
            icon="api"
          /> */}
          <BusinessButton
            theme="white"
            text="客服咨询"
            name="pop"
            onClick={onBtnClick}
            icon="consult"
            mr="0"
          />
        </Flex>
      </Box>
      <Box
        h={expand ? "1710px" : "700px"}
        overflow="hidden"
        pos="relative"
        pt="10px"
        transition="height 0.5s"
        bg="#F6F9FF"
      >
        <Flex
          w="1100px"
          mx="auto"
          flexWrap="wrap"
          css={{
            "& .business_imageCard": {
              marginRight: "24px",
              marginBottom: "32px",
            },
            "& .business_imageCard:nth-of-type(3n)": {
              marginRight: 0,
            },
          }}
        >
          {featureList.map((feature) => {
            return <ImageCard key={feature.title} {...feature} />;
          })}
        </Flex>
        <Flex
          pos={expand ? "relative" : "absolute"}
          bottom={0}
          w="100%"
          h="100px"
          justify="center"
          align="center"
          bg="linear-gradient(180deg, #ffffff50, #ffffff 80%)"
        >
          <Text
            display="flex"
            alignItems="center"
            color="#165DFF"
            cursor="pointer"
            onClick={expandOp.toggle}
          >
            {expand ? "收起" : "展开更多"}
            <DownCircle ml="0.5em" boxSize="20px" transform={`rotate(${expand ? 180 : 0}deg)`} />
          </Text>
        </Flex>
      </Box>
      <Box
        h="706px"
        overflow="hidden"
        bg="url('http://nolipix-js.nolibox.com/assets/creator/business/business_api_panel_bg.jpg')"
        bgSize="cover"
      >
        <Text fontSize="40px" color="white" textAlign="center" my="50px" fontWeight={600}>
          多种服务模式，适配各种业务需求
        </Text>
        <Flex
          justify="center"
          css={{
            "& .business_introCard": {
              marginRight: "24px",
              marginBottom: "32px",
            },
            "& .business_introCard:nth-of-type(3n)": {
              marginRight: 0,
            },
          }}
        >
          {serviceList.map((service) => {
            return <IntroCard key={service.title} {...service} />;
          })}
        </Flex>
      </Box>
    </Box>
  );
}

export default APIPanel;
